// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications[data-v-6b5ea2b2] {\n  z-index: 5;\n}", ""]);
// Exports
module.exports = exports;
